<script setup>
import { Tooltip } from 'floating-vue';

const props = defineProps({
  id: { type: String, default: '' },
  title: { type: String, default: '' },
  lines: { type: Array, default: () => [] },
  anchor: { type: Object, default: null },
  placement: { type: String, default: 'right' },
  visible: { type: Boolean, default: false },
});

const referenceNode = () => props.anchor?.$el || props.anchor;
</script>

<template>
  <Tooltip
    v-if="anchor"
    class="absolute"
    container="body"
    :reference-node="referenceNode"
    :aria-id="id"
    :placement="placement === 'below' ? 'bottom-start' : 'right-start'"
    :distance="12"
    :shown="visible"
    :triggers="[]"
    :popper-triggers="[]"
    :delay="0"
    popper-class="pointer-events-none [&_.v-popper__inner]:!border-0 [&_.v-popper__inner]:!bg-transparent [&_.v-popper__inner]:!p-0 [&_.v-popper__arrow-container]:hidden"
  >
    <template #popper>
      <span
        class="block w-52 rounded-xl bg-[#1F2328] px-3 py-3 text-xs text-white shadow-xl"
      >
        <span class="mb-2 block border-b border-white/15 pb-2 font-bold">{{
          title
        }}</span>
        <span
          v-for="line in lines"
          :key="line.label"
          class="mt-1 flex justify-between gap-3"
        >
          <span>{{ line.label }}</span>
          <span class="font-bold">{{ line.count }}</span>
        </span>
      </span>
    </template>
  </Tooltip>
</template>
